import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import { albumCover } from "constants/placeholderAlbumCover";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  name: string;
  artists: string;
  coverImage: string;
  activeTab: string;
  openModal: () => void;
}
const TrackDetails = ({
  coverImage = albumCover,
  name,
  artists,
  activeTab,
  openModal
}: IProps) => {
  return (
    <Container>
      <Details>
        <CoverImage src={coverImage} alt="Track Cover" />

        <div>
          <Typography weight="semibold" mb="0.4">
            {name}
          </Typography>
          <Typography size="xs" color={Colors.grey500}>
            {artists}
          </Typography>
        </div>
      </Details>
      {activeTab === "sync" ? (
        <RestartButton>
          <PrimaryButton
            onClick={openModal}
            variant="text"
            text="Restart Sync"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M15.3059 6.70887L14.7167 6.11961C12.1132 3.51612 7.89205 3.51612 5.28856 6.11961C2.68506 8.72307 2.68506 12.9442 5.28856 15.5477C7.89205 18.1512 12.1132 18.1512 14.7167 15.5477C16.2307 14.0337 16.8643 11.9727 16.6174 10.0007M15.3059 6.70887H11.7704M15.3059 6.70887V3.17334"
                  stroke="#FEB73D"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
            iconPosition="right"
            iconSize="2"
          />
        </RestartButton>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default TrackDetails;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Details = styled.div`
  display: flex;
  align-items: center;
`;

const CoverImage = styled.img`
  width: 4rem;
  height: 4rem;
  object-fit: contain;
  margin-right: 0.8rem;
  border-radius: 0.4rem;
`;

const RestartButton = styled.div`
  width: fit-content;
  margin-left: auto;
  margin-bottom: 2rem;
`;
